var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data && _vm.data.length >= 8)?_c('Cube',{attrs:{"dataMagic":_vm.data,"type":_vm.type,"autoplay":_vm.autoplay},on:{"clickItem":_vm.clickItem}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }